import {getConfig} from 'config';

const config = getConfig();

export const isTestEnvironment = () => config.REACT_APP_ENV === 'tst';
export const isDevEnvironment = () => config.REACT_APP_ENV === 'pdv';
